import { createReducer } from '../../../utils/fsa';

import {
  setSubsctiptionData,
  setoffer_id,
  subscribe,
  unsubscribe,
  setSubscribeState,
} from '../action_creators/price_change_subscription';

interface IPriceChangeSubscriptionData {
  offer_id: number;
  user_id?: string | void;
  uuid?: string;
  email?: string;
}

interface IPriceChangeSubscriptionState {
  offer_id: number;
  hasSubscription: boolean;
  unsubscribeFormState: boolean;
  subscriptionData: IPriceChangeSubscriptionData;
  user: 'user' | 'anonymus';
  formSend: boolean;
};

const priceChangeSubscriptionReducer = createReducer<IPriceChangeSubscriptionState>()
  .on(setoffer_id, (state, action) => {
    return Object.assign({}, state, {
      offer_id: action.payload.offer_id,
    });
  })
  .on(setSubsctiptionData, (state, action) => {
    return Object.assign({}, state, action.payload);
  })
  .on(subscribe, (state, action) => {
    return Object.assign({}, state, action.payload);
  })
  .on(unsubscribe, (state, action) => {
    return Object.assign({}, state, action.payload);
  })
  .on(setSubscribeState, (state, action) => {
    return Object.assign({}, state, action.payload);
  })
  .build({
    user: 'anonymus',
    formSend: false,
    offer_id: undefined,
    hasSubscription: false,
    unsubscribeFormState: false,
    subscriptionData: {
      offer_id: undefined,
      user_id: '',
      uuid: '',
      email: '',
    },
  });

export { IPriceChangeSubscriptionState, priceChangeSubscriptionReducer, IPriceChangeSubscriptionData }
export default priceChangeSubscriptionReducer;



// WEBPACK FOOTER //
// ./src/bundles/price_change_subscription/reducers/price_change_subscription.ts